import type { SectionWidgetConfig } from '../../types';
import { SportsWidgetType } from '../../widgets';
import { buildSportsSelfExcludedLayoutPageResponse } from '../buildSportsSelfExcludedLayoutPageResponse';

import { TXTWCL_Self_excluded_My_Bets } from './sportsSelfExcludedMyBets.messages.json';

const sportsSelfExcludedMyBetsWidgets = [
  {
    title: 'Sports My Bets Widget',
    _content_type_uid: SportsWidgetType.SportsMyBets
  }
] satisfies readonly SectionWidgetConfig[];

export const sportsSelfExcludedMyBets = buildSportsSelfExcludedLayoutPageResponse({
  alias: 'sportsSelfExcludedMyBets',
  seoConfig: {
    descriptionTag: TXTWCL_Self_excluded_My_Bets,
    noIndex: true,
    titleTag: TXTWCL_Self_excluded_My_Bets
  },
  mainSectionWidgetConfigs: sportsSelfExcludedMyBetsWidgets,
  limitMainSectionWidth: true
});
